import { forwardRef } from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { DocumentTemplateToc } from './DocumentTemplateToc';
import { DocumentTemplateContent } from './DocumentTemplateContent';

const DocumentTemplate = forwardRef((props, ref) => (
  <>
    <div className="d-lg-none text-start text-break p-0 common-formats-toc-content" style={{ position: 'sticky', top: 0, zIndex: 1000 }}>
      <DocumentTemplateToc data={{ commonFormatsData: props, isSideNav: false, extraSections: props.extraSections ?? [] }} ref={ref} />
    </div>

    <Row className="justify-content-center w-100">
      <Col
        lg={3}
        xxl={2}
        className="d-none d-lg-block ps-3 pe-3 ms-3 me-3 p-5 text-start text-break common-formats-border-right-dashed common-formats-toc-content"
      >
        <DocumentTemplateToc data={{ commonFormatsData: props, isSideNav: true, extraSections: props.extraSections ?? [] }} ref={ref} />
      </Col>

      <Col xxl={8} lg={7} md={12} className="ps-3 pe-3 ms-3 me-3 p-5 mb-3 text-start text-break common-formats-main-content">
        <DocumentTemplateContent data={props} levelHeadingClasses={props.levelHeadingClasses} ref={ref} />
      </Col>
    </Row>
  </>
));

export default DocumentTemplate;
